export const carrierClassifications = [
  "Freight",
  "FreightAndVehicle",
  "Vehicle",
] as const;

export type CarrierClassification = (typeof carrierClassifications)[number];
